<!-- 机构概况-底部tab -->
<template>
  <div class="tab-component">
    <div id="tab1">
      <div class="space-between mytab">
        <div class="tag">中心概况</div>
      </div>
      <p v-html="details.content" class="content"></p>
    </div>

    <div id="tab2">
      <div class="space-between mytab mt40">
        <div class="tag">科室职能</div>
      </div>

      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(item, i) in departmentData"
          :key="i"
          :title="item.departmentName"
          :name="i"
        >
          <div class="description" v-html="item.functionDescription"></div>
          <div
            class="link-text"
            v-if="item.linkUrl"
            @click="openLink(departmentData[isActiveI].linkUrl)"
          >
            <span v-if="item.linkName" class="mr5">{{ item.linkName }}</span>
            {{ item.linkUrl }}
          </div>
          <div
            class="attachments"
            v-if="item.attachmentList && item.attachmentList.length > 0"
          >
            <div
              class="download-document flex"
              v-for="(attach, j) in item.attachmentList"
              :key="j"
            >
              <i class="el-icon-paperclip"></i>
              <a
                class="itemName text_overflow"
                :href="path + attach.path"
                :download="'/' + attach.name"
                >{{ attach.name }}</a
              >
              <i
                class="el-icon-view"
                @click="opendialog(path + attach.path)"
                v-if="str.includes(attach.name.split('.')[1])"
              ></i>
              <a
                class="el-icon-download"
                :href="path + attach.path"
                :target="
                  str.includes(attach.name.split('.')[1]) ? '_blank' : ''
                "
                :download="'/' + attach.name"
              ></a>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div id="tab5">
      <div class="space-between mytab mt40">
        <div class="tag">承检能力</div>
      </div>

      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(item, i) in inspectionData"
          :key="i"
          :title="item.inspectionName"
          :name="i"
        >
          <div v-if="activeNames.includes(i)">
            <ul class="news-ul-li" style="height: 420px">
              <li
                class="space-between"
                v-for="(article, j) in (mobileListData[item.key] || []).filter(
                  (a) => a,
                )"
                :key="j"
                @click="
                  toDetails(
                    {
                      id: article.id,
                      title: '机构概况',
                      tag: '承检能力',
                    },
                    article.linkTo,
                  )
                "
              >
                <p class="text_overflow" :title="item.title">
                  {{ article.title }}
                </p>
                <span v-if="article.publishedDate || article.createdDate">{{
                  article.publishedDate
                    ? article.publishedDate.split(" ")[0]
                    : article.createdDate.split(" ")[0]
                }}</span>
              </li>
            </ul>
            <div class="pagination" style="justify-content: center">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.page"
                :page-sizes="[10, 20, 50, 60]"
                :page-size="params.size"
                layout="total, sizes, prev, slot, pager, next, jumper"
                :total="total"
                background
              >
                <span class="slot">
                  {{ params.page + 1 }}/{{ Math.ceil(total / 15) }}
                </span>
              </el-pagination>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div id="tab3">
      <div class="space-between mytab mt40">
        <div class="tag">中心领导</div>
      </div>
      <div class="list-leadership" v-for="(item, i) in leaderData" :key="i">
        <span> {{ item.position }}</span>
        <span style="cursor: pointer;" @click="
                onLeaderName(
                  {
                    id: item.id,
                    title: '机构概况',
                    tag:  item.name + '_' + (item.position ? item.position.replace(/\s/g, '') : '')
                  },
                  item.linkTo,
                )
              "> {{ item.name }}</span>
      </div>
    </div>

    <div id="tab4">
      <div class="space-between mytab mt40">
        <div class="tag">联系方式</div>
      </div>
      <div class="map-info">
        <b>单位地址</b>
        <span>南宁市江南区国凯大道东19号金凯工业园13号楼</span>
        <span>邮政编码:530031</span>
        <b>联系电话</b>
        <span>前台受理:0771-2800500 </span>
        <span>传真:0771-2800566</span>
        <span>其他科室电话详见公众服务栏目</span>
        <b>电子邮箱</b>
        <span>qjzx@yjj.gxzf.gov.cn</span>
        <div class="map" @click="tomap"></div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" fullscreen>
      <embed
        :src="pdfurl"
        width="100%"
        height="100%"
        type="application/pdf"
        v-if="pdfurl.includes('.pdf')"
      />
      <img :src="pdfurl" alt="" v-else />
    </el-dialog>
  </div>
</template>
<script>
import newsTab from "./../news/news-tab.vue";
import {
  getArticleDetails,
  getLeaderList,
  getDepartmentList,
  getArticleList,
  getKey,
} from "@/api/index";

export default {
  components: { newsTab },
  data() {
    return {
      activeNames: [0],
      details: {},
      departmentData: [],
      inspectionData: [],
      // 移动端承检能力每个分类的数据
      mobileListData: {},
      leaderData: [],
      functionDescription: "",
      isActiveI: 0,
      params: {
        page: 0,
        size: 10,
      },
      total: 0,
      path: process.env.VUE_APP_BASE_API,
      str: ["jpg", "png", "jpeg", "pdf"],
      dialogVisible: false,
      pdfurl: "",
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val) {
          this.scrollToAnchor(this.$route.hash.slice(1));
        }
      },
    },
    activeNames: {
      handler(newVal) {
        if (!this.inspectionData || this.inspectionData.length === 0) return;

        newVal.forEach((index) => {
          if (this.inspectionData[index] && !this.mobileListData[index]) {
            this.getArticleList(this.inspectionData[index].key, index);
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    // 点击科室职能链接打开
    openLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    onLeaderName(query, linkTo) {
      if (linkTo) {
        window.open(linkTo, "_blank");
      } else {
        this.$router.push({ path: "/leader-details", query });
      }
    },
    // 点击预览文件
    opendialog(url) {
      this.pdfurl = url;
      this.dialogVisible = true;
    },
    getCurrentTab(activeName) {
      this.activeName = activeName;
    },
    tomap() {
      window.open(
        "https://map.baidu.com/poi/%E5%B9%BF%E8%A5%BF%E5%A3%AE%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8C%BA%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E6%A3%80%E6%B5%8B%E4%B8%AD%E5%BF%83/@12057101.598829487,2585831.1455263617,20.32z?uid=2863c199f50218c3c909f040&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl",
        "_blank",
      );
    },
    getData() {
      // 获取中心概况的信息
      getArticleDetails(523)
        .then((res) => {
          this.details = res;
        })
        .finally(() => {});
      // 获取科室职能信息
      getDepartmentList()
        .then((res) => {
          this.departmentData = res.list;
          this.functionDescription = res.list[0].functionDescription;
        })
        .finally(() => {});
      // 获取领导信息

      getLeaderList()
        .then((res) => {
          this.leaderData = res.list;
        })
        .finally(() => {});
    },
    // 点击科室标题
    onDepartmentName(data, i) {
      this.functionDescription = data;
      this.isActiveI = i;
    },
    scrollToAnchor(id) {
      this.$nextTick(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "center" });
        }
      });
    },
    // 获取承检能力的信息
    getInspectionData() {
      const key = "generalize.inspection.id";
      getKey({ key: key })
        .then((res) => {
          if (res && res.children) {
            this.inspectionData = res.children.map((item) => ({
              inspectionName: item.name,
              key: item.configKey,
            }));

            if (this.inspectionData.length > 0) {
              // 默认触发第一个分类的数据加载
              this.getArticleList(this.inspectionData[0].key, 0);
            }
          } else {
            this.inspectionData = [];
          }
        })
        .catch((err) => {
          console.error("Failed to get download center data:", err);
          this.inspectionData = [];
        });
    },
    // 获取承检能力的列表数据
    getArticleList(key) {
      const params = {
        page: this.params.page,
        size: this.params.size,
        key: key,
      };
      getArticleList(params)
        .then((res) => {
          this.total = res.count;
          this.mobileListData[key] = res.list || [];
        })
        .finally(() => {});
    },
    handleSizeChange(val) {
      this.params.page = 0;
      this.params.size = val;
      this.getArticleList();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    // 点击分页
    handleCurrentChange(val) {
      this.params.page = val - 1;
      this.getArticleList();
    },
  },
  mounted() {
    if (this.$route.hash) {
      this.scrollToAnchor(this.$route.hash.slice(1));
    }
    this.getData();
    this.getInspectionData();
    if (this.inspectionData.length > 0) {
      this.getArticleList(this.inspectionData[0].key);
    }
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.tab-component {
  ::v-deep .el-collapse-item__header {
    height: 32px;
    background-color: #e4edfa;
    padding-left: 16px;
    font-size: 14px;
    border-radius: 4px;
  }
  .news-ul-li {
    background: none;
    overflow-y: scroll;
    padding: 0px 40px 20px;
    margin-bottom: 16px;
    li {
      min-height: 47px;
      border-bottom: 1px solid #14579e;
      &::before {
        top: 22px;
      }
      p {
        font-size: 22px;
        line-height: 50px;
      }
      span {
        font-size: 22px;
        line-height: 50px;
        width: 180px;
      }
    }
  }
  ::v-deep .el-collapse-item {
    margin-top: 16px;
  }
  ::v-deep .el-collapse-item__content {
    font-size: 14px;
    padding: 16px;
  }
  ::v-deep .el-collapse-item__header.is-active {
    font-weight: bold;
    font-size: 14px;
    color: #1b6ad2;
    line-height: 22px;
  }
  ::v-deep .el-collapse-item__arrow {
    margin-right: 16px;
  }
  ::v-deep .el-icon-arrow-right:before {
    content: "\25b2";
    font-size: 14px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
  }
  .list-leadership {
    height: 40px;
    width: 100%;
    background: url(../../assets/images/back_3.webp) no-repeat;
    background-size: 100% 21px;
    background-position: bottom;
    padding-left: 31px;
    margin-top: 16px;
    line-height: 40px;
    font-size: 14px;
    span {
      margin-right: 16px;
    }
  }
  .list-leadership:hover {
    color: #1b6ad2;
  }
  .map-info {
    b {
      display: block;
      color: #1b6ad2;
      margin-top: 16px;
    }
    span {
      display: block;
    }
    .map {
      width: 100%;
      height: 200px;
      background: url(../../assets/images/img_map_1.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 16px;
      margin-bottom: 40px;
    }
  }
  // ... existing styles ...

  .description {
    margin-bottom: 16px;
  }
  .mr5 {
    margin-right: 5px;
  }

  .link-text {
    color: #2381d4;
    cursor: pointer;
    margin-bottom: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
  .el-dialog__body {
    height: 100vh;
    padding: 0;
    background: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin: 0 auto;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 130px;
    .el-dialog__close {
      color: #fff;
    }
  }

  .attachments {
    margin-top: 16px;
    .download-document {
      align-items: center;
      margin-bottom: 12px;
      .itemName {
        margin: 0 12px;
        color: #2381d4;
      }
      .el-icon-paperclip {
        cursor: pointer;
        &::before {
          color: #2381d4;
        }
      }
      .el-icon-view,
      .el-icon-download {
        padding: 4px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        margin-right: 10px;
        transition: all 0.3s;
        &:hover {
          background-color: #2381d410;
          transform: scale(1.01);
        }
        &::before {
          color: #2381d4;
        }
      }
    }
  }
}
</style>
